import { render, staticRenderFns } from "./fullwidth.vue?vue&type=template&id=3321e4da"
import script from "./fullwidth.vue?vue&type=script&lang=ts"
export * from "./fullwidth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports